<template>
    <div class="show-lx-showLxRecord"
        v-loading="loading"
        :element-loading-text="$t('showLxRecord.PMJZZ')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <content-header>
            <div class="header-left-box" slot="header-left">
                <!-- <retuen-prev></retuen-prev> -->
                <div class="return-prev" @click="retuenPrev">
                    <span class="icon-box">
                        <span class="el-icon-arrow-left"></span>
                    </span>
                    <span class="return-text">{{$t('showLxRecord.FH')}}</span>
                </div>
                <content-header-title >
                    <slot>
                        <span>{{$t('showLxRecord.CKLXJL')}}</span>
                    </slot>
                </content-header-title>
            </div>
            <div slot="header-center">
                <slot name="header-center"></slot>
            </div>
            <div class="header-right" slot="header-right">
                <el-button plain size="small" @click="()=>{toolg('prev')}">{{$t('showLxRecord.SYC')}}</el-button>
                <el-select v-model="subVersionKeyId" size="small" @change="getStatisDetail" placeholder="">
                  <el-option :label="$t('showLxRecord.D')+item.sortNo+$t('showLxRecord.C')" :value="item.keyId" v-for="item in titleData.curScoreSortList" :key="item.sortNo"></el-option>
                </el-select>
                <el-button plain size="small" @click="()=>{toolg('next')}">{{$t('showLxRecord.XYC')}}</el-button>
            </div>
        </content-header>
        <div class="main">
            <div class="main-left-box">
                <team-show :planData="planData"></team-show>
                <div class="table-box">
                    <c-table
                        @operation="operation" 
                        :tableData="planData.itemDtoList" 
                        :ISChangeCheckout="false"
                        ref="c-table"
                        :tableHeader="lxTableHeader" 
                        :TableHeight="`calc( 100vh - ${375}px )`">
                    </c-table>
                </div>
            </div>
            <subject-type v-if="isShowAnswer" :paperData="paperData" :planData="planData"></subject-type>
        </div>
    </div>
</template>
<script>
import teamShow from '@/views/showLxRecord/team-show'
import CTable from '@/components/table'
import mins from './mins'
import subjectType from '@/views/showLxRecord/subject-type'
import fetch from '@/api/fetch'
import {Base64} from 'js-base64'
export default {
    name: 'showLxRecord',
    components:{
        teamShow,
        CTable,
        subjectType
    },
    mixins: [mins],
    created(){
        this.getTitle()
    },
    computed:{
        isShowAnswer(){
            if(this.__userData.type == 2){
                return this.answerFlag > 0 // 学生
            }else{
                return true
            }
        }
    },
    methods:{
        retuenPrev(){
            let teamDetailUrl = JSON.parse(sessionStorage.getItem('teamDetailUrl'))
            this.$router.push(teamDetailUrl)
        },
        getTitle(){
            let { planId, teamId, subVersion, mainVersion } = JSON.parse(Base64.decode(this.$route.query.q))
            fetch.statisTitle({
                planId,
                teamId
            }).then(res=>{
                if(res.code == "0"){
                    this.titleData = this.$parent.titleData = res.data
                    let index = this.titleData.curScoreSortList.findIndex(item=>item.mainVersion === mainVersion && item.subVersion === subVersion)
                    this.subVersionKeyId = this.titleData.curScoreSortList[index != -1 ? index : 0].keyId
                    this.getStatisDetail()
                }else{
                    this.$notify({ title: this.$t('showLxRecord.CZ'), message: res.msg || this.$t('showLxRecord.CZSB'), type: 'error' });
                }
            })
        },
        answerShow(key,index){
            this.$set(this.paperData[key][index],'isJX', !this.paperData[key][index].isJX)
        },
        getStatisDetail(){
            this.loading = true
            fetch.statisDetail({
                subVersionKeyId: this.subVersionKeyId
            }).then(res=>{
                if(res.code == 0){
                    this.loading = false
                    this.planData = res.data
                    sessionStorage.setItem('answerItemList', JSON.stringify(res.data.answerDto.answerItemList))
                    this.planData.itemDtoList = res.data && res.data.itemDtoList ? res.data.itemDtoList.map((item,index)=>({...item, sortNo: ++index, SystemScoring: item.objectiveScore + item.operScore, leaderFlagName: item.leaderFlag == 1 ? this.$t('showLxRecord.DZ') : this.$t('showLxRecord.DY'), score: Number(item.score) })) : []
                }else{
                    this.$notify({ title: this.$t('showLxRecord.CZ'), message: res.msg || this.$t('showLxRecord.CZSB'), type: 'error' });
                }
            })
        },
        setPaperList(rowData){
            // 设置练习数据
            let { answerDto={}, questionStationList } = this.planData
            let current = rowData || this.planData.itemDtoList[0] || {}
            let stationId = current.stationId
            this.$refs['c-table'].$refs['tableg'].setCurrentRow(current);
            let internalTypeName = {
                '1': this.$t('showLxRecord.DX'), // 单选
                '2': this.$t('showLxRecord.DXT'), // 多选题
                '3': this.$t('showLxRecord.PD'), // 判断
                '9': this.$t('showLxRecord.SC'), //实操
                '6': this.$t('showLxRecord.ZH'), //组合
                '10': this.$t('showLxRecord.SJFJT') // 审计附件题
            };
            let paperData = {
                '单选': [], '多选题': [], '判断': [], '实操': [], '组合': [],  '审计附件题': []
            };

            let paperStructContent = JSON.parse(answerDto.paperStructContent); // 试题源
            let paperResultContent = JSON.parse(answerDto.paperResultContent); // 答案源
            let answerItemList = answerDto.answerItemList // 学生答案 
            let questionList = questionStationList.map(item=>item.stationIdList.indexOf(stationId) != -1 ? item : false).filter(item=>item) // 拿到当前岗位对应的试题
            new Array().forEach.call(paperStructContent,itemTow=>{
                new Array().forEach.call(itemTow.testPaperPartsList,itemOne=>{
                    new Array().forEach.call(itemOne.testPaperSectionsList,itemThree=>{
                        new Array().forEach.call(itemThree.testPaperQuestionsList,itemFour=>{
                            if(questionList.find(item=>item.questionId == itemFour.questionId)){
                                let answerStudent = answerItemList.find(item=>item.questionId == itemFour.questionId) || {}; // 学生答案
                                let stationObj = questionStationList.find(item=>item.questionId == itemFour.questionId) || {}; //岗位数据
                                let answer = '';
                                for(let key in paperResultContent){
                                    if(key == itemFour.questionId){
                                        answer = paperResultContent[key];
                                        break;
                                    }
                                }
                                paperData[internalTypeName[itemFour.questionDto.internalTypeId]].push({...itemFour,paperCode: itemTow.paperCode, isJX: false, answerStudent,answer, stationObj: {...stationObj,stationId}})
                            }
                        })
                    })
                })
            })
            for(let key in paperData){
                if(!paperData[key].length){
                    delete paperData[key]
                }
            }
            this.paperData = paperData
        },
        toolg(type){
            // 切换次数
            let curIndex = this.titleData.curScoreSortList.findIndex(item=>item.keyId === this.subVersionKeyId)
            if(type === 'prev'){
                if(curIndex === 0){
                    // 当前是第一个
                    this.$notify({ title: this.$t('showLxRecord.CZ'), message: this.$t('showLxRecord.DQDYC'), type: 'warning' });
                    return false
                }else{
                    let { keyId } = this.titleData.curScoreSortList[curIndex - 1]
                    this.subVersionKeyId = keyId

                }
            }else{
                if((this.titleData.curScoreSortList.length - 1) === curIndex){
                    // 当前是最后一个
                    this.$notify({ title: this.$t('showLxRecord.CZ'), message: this.$t('showLxRecord.DQZHYC'), type: 'warning' });
                    return false
                }else{
                    let { keyId } = this.titleData.curScoreSortList[curIndex + 1]
                    this.subVersionKeyId = keyId
                }
            }
            this.getStatisDetail()
        },
        toolgTeam(){
            this.subVersionKeyId = this.titleData.curScoreSortList[0].keyId
            this.getStatisDetail(this.titleData.curTeamId)
        }
    }
}
</script>
<style lang="scss" scoped>
.header-left-box{
    display: flex;
    .return-prev{
        cursor: pointer;
        color: #858C96;
        .icon-box{
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #B4BBCD;
            opacity: 0.2;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            color: #000;
            display: inline-block;
            vertical-align: 1px;
        }
        .return-text{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            letter-spacing: 1px;
            margin: 0 14px 0 6px;
            vertical-align: 1px;
        }
    }
    .return-prev:hover{
        color: #5397F7;
        .icon-box{
            color: #5397F7;
            opacity: .5;
        }
    }
}
/deep/ .el-select{
    margin: 0 8px;
    width: 100px;
    .el-input__inner{
        background: #5397F7;
        color: #fff;
    }
    .el-select__caret{
        color: #fff !important;
    }
}
.main{
    padding: 12px 24px;
    display: flex;
    box-sizing: border-box;
    .main-left-box{
        width: 48%;
        margin-right: 32px;
    }
}
</style>